<!--
 * @Author: Tahiti
 * @Date: 2025-11-06
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-26 15:11:45
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/SingleImgEdit.vue
-->
<template>
    <div
        class="text-sm px-3 gap-3 py-1 text-white flex items-center justify-center min-h-[28px] border border-[#1D1D20] rounded-[10px] bg-[#101012]"
    >
        <el-dropdown
            class="flex items-center"
            :show-arrow="false"
            popper-style="popper"
            popper-class="generate-popper"
            trigger="hover"
        >
            <!-- Element Plus 会给 trigger 注入 el-tooltip__trigger 并设置默认灰色，强制白色保证对比度 -->
            <span class="flex items-center text-sm gap-[10px] !text-white">
                {{ modeList.find(item => item.value === generate_type)?.name }}
                <span class="i-down-icon w-3 h-3"></span>
            </span>
            <template #dropdown>
                <el-dropdown-menu class="custom !px-2">
                    <el-dropdown-item
                        v-for="item in modeList"
                        :key="item.value"
                        class="flex  items-center justify-between gap-6 !p-[10px]"
                        :class="{
                            ' rounded-[10px]':
                                generate_type === item.value,
                        }"
                        @click="generate_type = item.value"
                    >
                        <span class="flex flex-col items-start">
                            <span class="text-white text-sm font-medium">{{
                                item.name
                            }}</span>
                            <span class="text-text-adad max-w-[200px] whitespace-normal text-xs">{{
                                item.desc
                            }}</span>
                        </span>

                        <svg
                            v-if="generate_type === item.value"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            class="w-5 h-5"
                        >
                            <path
                                d="M16.6663 5L7.49967 14.1667L3.33301 10"
                                stroke="#99F768"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from '~/composables/useI18n'
import { computed } from 'vue'
const { t, locale } = useI18n()
const generate_type = defineModel('generate_type', {
    type: String,
    default: 'standard',
})

const props = defineProps(['type'])

const modeList = computed(() => {
    const list = [
        {
            name: t('batchTools.standardMode'),
            desc: t('batchTools.standardDesc'),
            value: 'standard',
        },
        {
            name: t('batchTools.batchMode'),
            desc: t('batchTools.batchGenerateDesc'),
            value: 'batch',
        },
        {
            name: t('batchTools.singleMode'),
            desc: t('batchTools.singleImgEditDesc'),
            value: 'single',
        },
    ]

    if (props.type === 'text_to_image') {
        return list.filter(item => item.value !== 'single')
    }
    return list
})
</script>

<style scoped lang="less">
:deep(.el-popper .is-light) {
    border-radius: 10px;
}
</style>
